import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { userType } from 'app/helpers/userType';
import { useSelector } from 'react-redux';

function PrivateRoute({ children, permission }) {
  const token = useSelector((state) => state?.auth?.token);
  const { isMA } = userType();

  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  // Decided during render so a protected page never mounts (or calls its
  // APIs) before the redirect.
  const storedPermissions = JSON.parse(localStorage.getItem('permission'));
  const hasPermission =
    isMA ||
    !permission ||
    (Array.isArray(storedPermissions) &&
      storedPermissions.some((num) => num?.name === permission));

  useEffect(() => {
    if (!token && pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
  }, [pathname, requestedLocation, token]);

  if (!token) {
    return <Navigate to="/login" />;
  }
  if (!hasPermission) {
    return <Navigate to="/401" />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return children;
}

PrivateRoute.propTypes = {
  children: PropTypes.node,
};

export default PrivateRoute;
